export default __webpack_public_path__ + "static/media/other_icon.a4fa69e7.svg";